export const GET_FRUITS = "GET_FRUITS";
export const GET_FRUIT_UPDATE = "GET_FRUIT_UPDATE";
export const COPY_FRUIT = "COPY_FRUIT"
export const FRUITS_LIST = "FRUITS_LIST"